import { createElement } from 'react';
import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import {
  IVirtualManifestBuilderProps,
  ComponentsPlatformService,
} from '@wix/editor-platform-manifest-services';
import { CompRef } from '@wix/document-services-types';
import { GlobalDesignPanel } from '../../../../ui/globalDesignPanel';
import { buildGlobalDesignContext } from '../nativeActions/globalDesign/contextBuilder';
import { BaseActionPanelAPI } from './BaseActionPanelAPI';
import { EditActionsPresetsStore } from '../stylePresets/editActionsPresetsStore';
import { t } from '../../../../essentials/i18n';
import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

export class GlobalDesignActionPanelAPI extends BaseActionPanelAPI {
  constructor(
    readonly editorPointers: EditorPointer<CompRef>[],
    readonly actionName: StylesDerivedNativeActionNames,
    readonly editorPointerAPI: EditorPointerServiceAPI,
    readonly componentsAPI: ComponentsPlatformService,
  ) {
    super();
  }

  getContent() {
    const stylePresets = EditActionsPresetsStore.getStylePresets(
      this.actionName,
    );

    return createElement(
      GlobalDesignPanel,
      {
        editorPointers: this.editorPointers,
        actionName: this.actionName,
        getHost: this.getHost,
        componentsAPI: this.componentsAPI,
        stylePresets,
        t,
      },
      null,
    );
  }

  private createContextBuilder(): IVirtualManifestBuilderProps['contextBuilder'] {
    return buildGlobalDesignContext(
      this.editorPointers,
      this.actionName,
      this.editorPointerAPI,
    );
  }

  async getHostContext(props?: IVirtualManifestBuilderProps) {
    return this.getInfraSDKHostContext({
      ...props,
      contextBuilder: props?.contextBuilder ?? this.createContextBuilder(),
    });
  }
}
